import * as React from "react"
import { useEffect, useState } from 'react'
import { useTable, useSortBy } from 'react-table'
import { Link } from "react-router-dom"
import styled from 'styled-components'
import Form from 'react-bootstrap/Form'

const StyledTable = styled.div`

    .searchInput {
        margin-bottom: 10px;
    }

    table {
        border-spacing: 0;
        border: 1px solid lightgrey;
        margin-bottom: 20px;

        tr {
            :last-child {
                td {
                    border-bottom: 0;
                }
            }

            :hover {
                background-color: #f6f6f6;
            }
        }

        th,
        td {
            margin: 0;
            padding: 0.5rem;
            border-bottom: 1px solid lightgrey;
            border-right: 1px solid lightgrey;

            :last-child {
                border-right: 0;
            }
        }

        th {
            background-color: #ebfafc !important;
        }
    }
`

function DataTable(props) {
    const [columns, setColumns] = useState([])
    const [searchValue, setSearchValue] = useState("")
    const [filteredRows, setFilteredRows] = useState([])
    const data = props.data
    let {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable(
        {
            columns,
            data,
        },
        useSortBy
    )

    useEffect(() => {
        props.columns.forEach(column => {
            const header = column.Header
            if (header.includes("(€)")) {
                column.Cell = ({value}) => parseFloat(value).toLocaleString('de-DE')
            }
            if (column.type === "tinyint") {
                column.Cell = ({value}) => parseInt(value) ? "Si" : "No"
                return
            }
            if (column.type === "image") {
                column.Cell = ({value}) => !!value
                    ? <img width="150" src={`${props.filePath}/${value}`} />
                    : null
                return
            }
        })
        if (props.detailURL) {
            for (const column of props.columns) {
                if (column.accessor !== "id" && column.type !== "image") {
                    column.Cell = ({row, value}) => (
                        <Link to={props.detailURL.replace('{id}', row.original.id)}>
                            {value}
                        </Link>
                    )
                    break
                }
            }
        }
        setColumns(props.columns)

    }, [props.columns])

    useEffect(() => {
        setFilteredRows(rows)
    }, [rows])

    useEffect(() => {
        search(searchValue)
    }, [searchValue])

    const search = (str) => {
        if (!rows || !rows.length) {
            return
        }
        if (!str) {
            setFilteredRows(rows)
            return
        }
        const lowerValue = removeAccents(str.toLowerCase())
        const filteredRows = rows.filter(row => removeAccents(Object.values(row.values).join('').toLowerCase()).includes(lowerValue))
        setFilteredRows(filteredRows)
    }

    const removeAccents = (str) => {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    }

    return (
        <StyledTable>
            <Form.Control
                placeholder={props.searchPlaceholder}
                onChange={e => setSearchValue(e.target.value)}
                className="searchInput"
            />
            <table {...getTableProps()}>
                <thead>
                    {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map(column => (
                            <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                {column.render('Header')}
                                <span>
                                    {column.isSorted
                                    ? column.isSortedDesc
                                        ? ' 🔽'
                                        : ' 🔼'
                                    : ''}
                                </span>
                            </th>
                        ))}
                    </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {filteredRows.map((row, i) => {
                        prepareRow(row)
                        return (
                            <tr {...row.getRowProps()}>
                                {row.cells.map(cell => (
                                    <td {...cell.getCellProps()}>
                                        {cell.render('Cell')}
                                    </td>
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </StyledTable>
    );
}
export default DataTable;